export const DESCRIPTIVE_ROW_DIALOG_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.DescriptiveRowDialogWidgetElement';
